<template>
  <div>
    <v-radio-group v-model="localScheduleType" @change="onChange">
      <v-radio :key="1" label="Lịch lặp hàng tuần" value="weekly-schedule"></v-radio>
      <v-radio :key="2" label="Lịch tự do" value="free-schedule"></v-radio>
    </v-radio-group>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: 'weekly-schedule',
    },
  },
  data() {
    return {
      localScheduleType: this.value,
    }
  },
  methods: {
    onChange() {
      this.$emit('input', this.localScheduleType)
      this.$emit('change', this.localScheduleType)
    },
  },
}
</script>
